export const ACCEPTED_FILE_TYPES = ['GIF', 'JPG', 'JPEG', 'PNG', 'PDF', 'DOC', 'DOCX', 'XLS', 'XLSX'];